// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "sniff_group_home/js/" + chunkId + "." + "34b72039" + ".chunk.js";
};